import { ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { usePermissions } from 'app/api/permission-queries';

interface PermissionGuardProps {
  documentId: string;
  sectionId?: string;
  requiredPermissions?: string[];
  requiredSectionPermissions?: string[];
  fallback?: ReactNode;
  children: ReactNode;
}

export const PermissionGuard = ({
  documentId,
  sectionId,
  requiredPermissions = [],
  requiredSectionPermissions = [],
  fallback = <Navigate to="/" replace />,
  children,
}: PermissionGuardProps) => {
  const { documentPermissions, sectionPermissions, isLoading } = usePermissions(documentId);

  if (isLoading) return <p>Loading permissions</p>;

  const allowed = sectionId
    ? sectionId in sectionPermissions && requiredSectionPermissions.includes(sectionPermissions[sectionId])
    : requiredPermissions.some((permission) => documentPermissions.includes(permission));

  return <>{allowed ? children : fallback}</>;
};
